module.exports = __webpack_public_path__ + "fonts/NunitoSans-SemiBoldItalic.80f346b.ttf";